import { View, Text, TouchableOpacity, TextInput, Image } from "react-native";
import React, { useRef, useState } from "react";
import AttachIcon from "../../assets/svg/AttachIcon";
import MicrophoneIcon from "../../assets/svg/MicrophoneIcon";
import { danger, gray, primary, shadowSm, white } from "../../colors";
import SendIcon from "../../assets/svg/SendIcon";
import { useSelector } from "react-redux";
import * as ImagePicker from "expo-image-picker";
import { Ionicons, Feather } from "@expo/vector-icons";
import MyButton from "../custom/MyButton";
import { Audio } from "expo-av";
import MyText from "../custom/MyText";
import axios from "axios";
import { useEffect } from "react";
import newMessage from "../../api/support/newMessage";
import translate from "../../functions/translate";
import { Platform } from "react-native";

let timerInterval = null;
export default function SupportChatInput() {
  const [mode, setMode] = useState(1);
  const main = useSelector((store) => store.main);

  const [textMessage, setTextMessage] = useState(null);

  const [recording, setRecording] = useState();
  const [isRecording, setIsRecording] = useState(false);
  const [recordingSeconds, setRecordingSeconds] = useState(0);
  const [sound, setSound] = useState(null);
  useEffect(() => {
    if (
      textMessage === null ||
      textMessage === "" ||
      textMessage === undefined
    ) {
      setMode(1);
    }
  }, [textMessage]);
  async function startRecording() {
    setRecordingSeconds(0);
    timerInterval = setInterval(() => {
      setRecordingSeconds((prev) => prev + 1);
    }, 1000);
    try {
      await Audio.requestPermissionsAsync();
      await Audio.setAudioModeAsync({
        allowsRecordingIOS: true,
        playsInSilentModeIOS: true,
      });

      const { recording } = await Audio.Recording.createAsync(
        Audio.RecordingOptionsPresets.HIGH_QUALITY
      );
      setRecording(recording);

      setIsRecording(true);
      setMode(3);
    } catch (err) {
      console.error("Failed to start recording", err);
    }
  }

  async function stopRecording() {
    setRecordingSeconds(0);
    clearInterval(timerInterval);

    setRecording(undefined);
    await recording.stopAndUnloadAsync();
    await Audio.setAudioModeAsync({
      allowsRecordingIOS: false,
    });
    const uri = recording.getURI();

    setRecording(false);
    setMode(1);
  }
  async function playSound() {
    const { sound } = await Audio.Sound.createAsync({
      uri: recording.getURI(),
    });
    setSound(sound);

    await sound.playAsync();
  }
  const sendTextMessage = () => {
    newMessage("text", textMessage)
      .then(({ data }) => {})
      .catch((err) => {});
    setTextMessage("");
    setMode(1);
  };
  const [image, setImage] = useState(null);
  const changeHandler = (event) => {
    setImage(event.target.files[0]);
  };
  const fileInput = useRef(null);
  const selectFile = () => {
    fileInput.current.click();
  };
  const [imageSend, setImageSend] = useState(false);
  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: false,
      quality: 1,
    });

    if (!result.canceled) {
      setImage(result);
    }
  };
  const sendImage = () => {
    setImageSend(true);
    const headers = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
      origin: "https://manager.asqtest.ir",
    };
    if (
      Platform.OS === "web" &&
      fileInput.current !== undefined &&
      fileInput.current.value !== undefined
    ) {
      const data = new FormData();
      data.append("token", main.token);
      data.append("type", "image");
      data.append("value", image);
      axios
        .post("https://api.asqtest.ir/ticket/sendTicketDoctor", data, {
          headers: headers,
        })
        .then((response) => {
          fileInput.current.value = "";
          setImageSend(false);
        })
        .catch((error) => {});
    } else if (Platform.OS !== "web" && image !== null) {
      const data = new FormData();
      data.append("token", main.token);
      data.append("type", "image");
      data.append("value", {
        uri: image.uri,
        type: "image/png", // or photo.type
        name: "avatar.png",
      });

      axios
        .post("https://api.asqtest.ir/ticket/sendTicketDoctor", data, {
          headers: headers,
        })
        .then((response) => {
          setImageSend(false);
          setImage(null);
        })
        .catch((error) => {});
    }
  };
  const sendVoiceMessage = async () => {
    setRecordingSeconds(0);
    clearInterval(timerInterval);
    setMode(4);

    setRecording(undefined);
    await recording.stopAndUnloadAsync();
    await Audio.setAudioModeAsync({
      allowsRecordingIOS: false,
    });
    const uri = recording.getURI();

    const headers = {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    };

    newMessage("audio", uri).then(({ data }) => {
      setRecording(false);
      setMode(1);
    });
  };

  return (
    <View
      style={{
        alignItems: "center",
        zIndex: 100,
        backgroundColor: white,
        bottom: 0,
      }}
    >
      <View
        style={{ width: "94%", flexDirection: "row", alignItems: "center" }}
      >
        {(mode === 1 || mode === 2) && (
          <View style={{ flex: 1 }}>
            <TextInput
              value={textMessage}
              onChangeText={(text) => {
                setTextMessage(text);
                text === "" ? setMode(1) : mode !== 2 ? setMode(2) : null;
              }}
              multiline={true}
              style={{
                height: 50,
                borderColor: gray,
                borderWidth: 1,
                borderRadius: 15,
                padding: 10,
                alignItems: "center",
                marginRight: 5,
              }}
            />
          </View>
        )}
        {mode === 3 && (
          <View
            style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
          >
            <View>
              <MyText>{`${Math.floor(recordingSeconds / 60).toString()} : ${(
                recordingSeconds % 60
              )
                .toString()
                .padStart(2, 0)}`}</MyText>
            </View>
          </View>
        )}
        {mode === 1 && (
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            {Platform.OS === "web" ? (
              <input
                type="file"
                style={{ display: "none" }}
                ref={fileInput}
                onChange={changeHandler}
              />
            ) : null}
            <TouchableOpacity
              style={{ marginHorizontal: 3 }}
              onPress={Platform.OS === "web" ? selectFile : pickImage}
            >
              <AttachIcon />
            </TouchableOpacity>
            {Platform.OS !== "web" && (
              <TouchableOpacity
                onPress={recording ? stopRecording : startRecording}
                style={{ marginHorizontal: 3 }}
              >
                <MicrophoneIcon />
              </TouchableOpacity>
            )}
          </View>
        )}
        {mode === 2 && (
          <TouchableOpacity
            onPress={sendTextMessage}
            style={{
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: primary,
              padding: 5,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 15,
              minWidth: 60,
              minHeight: 45,
            }}
          >
            <View
              style={{ transform: [{ rotate: main.rtl ? "0deg" : "180deg" }] }}
            >
              <SendIcon />
            </View>
          </TouchableOpacity>
        )}
        {mode === 3 && (
          <View style={{ flexDirection: "row" }}>
            <TouchableOpacity
              onPress={stopRecording}
              style={{
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: danger,
                padding: 5,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 15,
                minWidth: 50,
                minHeight: 40,
              }}
            >
              <View
                style={{
                  transform: [{ rotate: main.rtl ? "0deg" : "180deg" }],
                }}
              >
                <Feather name="x" size={24} color="white" />
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={sendVoiceMessage}
              style={{
                marginHorizontal: 5,
                flexDirection: "row",
                alignItems: "center",
                backgroundColor: primary,
                padding: 5,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 15,
                minWidth: 50,
                minHeight: 40,
              }}
            >
              <View
                style={{
                  transform: [{ rotate: main.rtl ? "0deg" : "180deg" }],
                }}
              >
                <SendIcon />
              </View>
            </TouchableOpacity>
          </View>
        )}
      </View>
      <View style={{ width: "100%", alignItems: "center" }}>
        {Platform.OS === "web" &&
          fileInput.current !== null &&
          fileInput.current?.value !== "" && (
            <View
              style={{
                marginVertical: 10,
                padding: 10,
                width: "90%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setImage(null);
                  fileInput.current.value = "";
                }}
              >
                <Ionicons name="close" size={24} color={danger} />
              </TouchableOpacity>
              <MyText>فایل آپلود شده</MyText>
              <View
                style={{ width: "100%", alignItems: "center", marginTop: 20 }}
              >
                <MyButton
                  onPress={() => (imageSend ? null : sendImage())}
                  text={imageSend ? translate("sending") : translate("send")}
                />
              </View>
            </View>
          )}
        {image && Platform.OS !== "web" && (
          <View
            style={{
              marginVertical: 10,
              padding: 10,
              width: "90%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TouchableOpacity onPress={() => setImage(null)}>
              <Ionicons name="close" size={24} color={danger} />
            </TouchableOpacity>
            <View style={{ width: "100%", alignItems: "center" }}>
              <Image
                source={{ uri: image.assets[0].uri }}
                style={{ width: 160, height: 160, marginTop: 10 }}
              />
            </View>
            <View
              style={{ width: "100%", alignItems: "center", marginTop: 20 }}
            >
              <MyButton
                onPress={() => (imageSend ? null : sendImage())}
                text={imageSend ? translate("sending") : translate("send")}
              />
            </View>
          </View>
        )}
      </View>
    </View>
  );
}
